import React from "react";
import AppBar from "@mui/material/AppBar";
import { alpha } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import { RefineThemedLayoutV2HeaderProps } from "@refinedev/mui";
import { getRuntimeEnv } from "../../../providers/getRuntimeEnv";
import { SidebarToggle } from "../Header";
import { AdminUserMenu } from "./AdminUserMenu";
import { DevLinks } from "./DevLinks";
import { EnvBadge, PILL_HEIGHT } from "./EnvBadge";

// Header of the admin area: same AppBar and sidebar toggle as the seller
// Header, without the seller-only controls (order search, store selector,
// marketplace clock, workspace drawer). On every admin page it shows which
// environment this is (left, a status pill); on the test environment a tool
// pill of the same shape holds the developers' menu; then the account menu.
export const AdminHeader: React.FC<RefineThemedLayoutV2HeaderProps> = ({
  sticky = false,
}) => {
  const dev = getRuntimeEnv() === "dev";

  return (
    <AppBar position={sticky ? "sticky" : "relative"}>
      <Toolbar sx={{ gap: 2 }}>
        <SidebarToggle />
        <EnvBadge />
        <Box sx={{ flexGrow: 1 }} />
        <Stack
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
          gap={2}
          sx={{ flexShrink: 0 }}
        >
          {dev && (
            <Stack
              direction="row"
              alignItems="center"
              sx={{
                display: { xs: "none", md: "flex" },
                height: PILL_HEIGHT,
                px: 0.75,
                borderRadius: 2,
                border: "1px solid",
                borderColor: "divider",
                bgcolor: (theme) => alpha(theme.palette.text.primary, 0.03),
              }}
            >
              <DevLinks />
            </Stack>
          )}
          <Box sx={{ width: 220 }}>
            <AdminUserMenu />
          </Box>
        </Stack>
      </Toolbar>
    </AppBar>
  );
};
